import React from 'react';
import PropTypes from 'prop-types';
import {useTranslate} from '@computerrock/formation-i18n';
import {alfMessageChannelTypes} from '@ace-de/eua-entity-types';
import {useStyles} from '@ace-de/ui-components';
import {SelectField, Option, InputEmailField} from '@ace-de/ui-components/form';
import styles from '../modals/CommunicationModals.module.scss';

const mandatoryFieldSets = {
    [alfMessageChannelTypes.EMAIL]: ['toEmail', 'sender'],
};

const EmailFormFields = props => {
    const {cx} = useStyles(props, styles);
    const {emailFormData, onFieldChange, senderAccounts, isDisabled, isToEmailDisabled} = props;
    const {createTranslateShorthand, translate} = useTranslate();
    const translateModal = createTranslateShorthand('send_message_modal');

    return (
        <>
            <SelectField
                name="sender"
                label={translateModal('select_field_label.sender')}
                className={cx('global!ace-u-margin--bottom-32', 'global!ace-u-full-width')}
                value={emailFormData?.sender || ''}
                onChange={value => onFieldChange('sender', value)}
                isDisabled={isDisabled}
            >
                {senderAccounts && senderAccounts.map(sender => (
                    <Option
                        value={sender.type}
                        name={`emailSender${sender.type}`}
                        key={sender.type}
                    >
                        {sender.email}
                    </Option>
                ))}
            </SelectField>
            <InputEmailField
                className={cx('global!ace-u-margin--bottom-32', 'global!ace-u-full-width')}
                name="toEmail"
                label={translateModal('input_field_label.to_email')}
                value={emailFormData?.toEmail || ''}
                onChange={value => onFieldChange('toEmail', value)}
                invalidEmailError={translate('global.email_error.wrong_format')}
                isDisabled={isDisabled || isToEmailDisabled}
                onEmailValidation={props.onEmailValidation}
                isRequired={mandatoryFieldSets[alfMessageChannelTypes.EMAIL].find(field => (
                    field === 'toEmail'
                ))}
                emptyFieldError={translate('global.input_field_error.mandatory_field')}
            />
        </>
    );
};

EmailFormFields.propTypes = {
    emailFormData: PropTypes.object.isRequired,
    onFieldChange: PropTypes.func.isRequired,
    senderAccounts: PropTypes.array,
    isDisabled: PropTypes.bool,
    onEmailValidation: PropTypes.func.isRequired,
    isToEmailDisabled: PropTypes.bool,
};

EmailFormFields.defaultProps = {
    senderAccounts: [],
    isDisabled: false,
    isToEmailDisabled: false,
};

export default EmailFormFields;
